module.exports = __webpack_public_path__ + "img/img_clip.916bc51c.png";